

































import Vue from 'vue';
import Component from 'vue-class-component';
import genericapi  from '../assets/ts/genericAPIAxios';

@Component
export default class RedirectPage extends Vue {
  private label = [];
  //private configurationName: string = 'PAYMENT';
  private imageFolderPath: string = '';
  //private SubmitterInfo: any = {};
  //private filingResponse: any = {};
  private doAutomaticRedirect: boolean = false;
  private automaticRedirectTime:string = '0';
  
  private created() {
    if (this.empty(this.label) || this.label.length === 0) {
     this.fetchLabels().then((labelResponse: any) => {
       console.log(labelResponse);
       this.label = labelResponse;
        // console.log('first pragraph:'+this.label.EBIENNIAL_HOME_PARAGRAPH_1);
            this.doAutomaticRedirect = this.getLabelValue('EBIENNIAL_AUTO_REDIRECT');
            this.automaticRedirectTime = this.getLabelValue('EBIENNIAL_AUTO_REDIRECT_TIME');
            console.log('doAutomaticRedirect:'+this.doAutomaticRedirect);
            console.log('automaticRedirectTime:'+this.automaticRedirectTime);
            console.log('Inside created of first page');
            if(this.doAutomaticRedirect){
              setTimeout( () => 
              //this.$router.push({ path: '/home'}), 
              window.location.href = this.getLabelValue('EBIENNIAL_REDIRECT_NEW_PAGE'),
              parseInt(this.automaticRedirectTime));
            }

      });
    }
    console.log('imageFolderPath:' + this.imageFolderPath);
  }
  private getLabelValue(keyPassed: string) {
    for (let i = 0; i < this.label.length; i++) {
      for (const key in this.label[i] ) {
        if (key === keyPassed) {
          console.log('Matched if');
          return this.label[i][key];
        }

      }
    }
  }
  private getImageURL(columnname: string) {
     const images = require.context('@/assets/images/', true, /\.jpg$/);
     return images('./' + this.getLabelValue(columnname));
    // return this.getLabelValue(columnname);
  }
  private fetchLabels() {
     // return this.$http.get('Ebiennial/GetConfigurationData', {
      //  return genericapi.get('Ebiennial/GetConfigurationData', {
        return genericapi.get('Generic/GetConfigurationData', {
          params: {
          group: 'SECTION',
          application: 'EBIENNIAL',
      },

    }).then((response: any) => {
      console.log(response);
      return response.data;
    }).catch((error: any) => {
      console.log(error);
    });
  }
  private empty(e) {
    switch (e) {
      case '':
      case '':
      case 0:
      case '0':
      case null:
      case false:
      case typeof this === 'undefined':
      case typeof this === undefined:
      return true;
      default:
        return false;
    }
  }
 }
